import { FC } from "react";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { FlexBox, FlexRow } from "components/flex-box";
import { H5, Paragraph, Span } from "components/Typography";
import { Box, Container } from "@mui/material";
import CategorySectionHeader from "components/CategorySectionHeader";
import { colors } from "common";
import BazarImage from "components/BazarImage";
import { useCompanyInfo } from "hooks/useCompanyInfo";
import { useLinkHandler } from "hooks";
import { useAppSelector } from "hooks/use-app-selector";
import modules from "modules";
import BranchInfo from "components/footer/BranchInfo";
import { LocalPhone, PhoneAndroid, Place } from "@mui/icons-material";

const { selectors: branchesSelectors, actions: branchesActions } =
  modules.branch;

// ===============================================================
type Props = {};
// ===============================================================

const branches = [
  {
    branchName: "PC WORTH EXPERIENCE Q.C ",
    address: "7 J.P. Rizal st, Cor Malong, Project 4, Quezon City, 1109 ",
    telNo: "(02)7 002 0176",
    cellNo: "(+63) 947-357-1727",
    cellNo2: "",
    openHours: "9:00am to 9:00pm ",
  },
  {
    branchName: "SAMPALOC BRANCH",
    address: "618 M Earnshaw St. Sampaloc Manila ",
    telNo: "(02)8 656 0586",
    cellNo: "0998 594 3037",
    cellNo2: "(+63) 998 594 3037",
    openHours: "9:00am to 9:00pm ",
  },
  {
    branchName: "ALABANG-ZAPOTE BRANCH ",
    address: "2nd Floor Philhealth Alabang-Zapote Road ",
    telNo: "(02)8 292 9044",
    cellNo: "0931 062 1294 ",
    cellNo2: "",
    openHours: "11:00am to 8:00pm",
  },
];

const ContactUsPage: FC<Props> = ({}) => {
  const { companyInfoData } = useCompanyInfo();
  const branchesData = useAppSelector(branchesSelectors.selectBranches);
  const { openFacebookPage } = useLinkHandler();
  return (
    <ShopLayout1 title="Contact Us" navbar={<Navbar />}>
      <Container maxWidth="lg" sx={{ p: 3 }}>
        <CategorySectionHeader title="Contact Us" />
        <BazarImage
          alt="contact-us"
          src={"/assets/images/banners/contact-us.png"}
          sx={{ width: "100%", mt: 2 }}
        />
        <FlexRow alignItems="center" mt={5}>
          <Container
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <H5 color="grey.800" marginLeft={-2}>
              Branch Details:
            </H5>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: 4,
                flexWrap: "wrap",
              }}
            >
              {branches.map((branch, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: "1 1 200px",
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    p: 2,
                  }}
                >
                  <Box color="#000000" fontWeight="bold" mb={1}>
                    {branch.branchName}:
                  </Box>
                  <FlexBox gap={1} alignItems="flex-start">
                    {" "}
                    <Place fontSize="small" sx={{ fontSize: 17, mt: "3px" }} />
                    <Span color="#000000"> {branch.address}</Span>
                  </FlexBox>
                  {branch.telNo && (
                    <FlexBox gap={1} alignItems="center">
                      <LocalPhone
                        fontSize="small"
                        sx={{ fontSize: 17, mt: "3px" }}
                      />
                      <Span color="#000000">{branch.telNo}</Span>
                    </FlexBox>
                  )}
                  {branch.cellNo2 ? (
                    <FlexBox mb={2} gap={1} alignItems="center">
                      <PhoneAndroid
                        fontSize="small"
                        sx={{ fontSize: 17, mt: "3px" }}
                      />
                      <Span color="#000000">
                        {branch.cellNo} / {branch.cellNo2}
                      </Span>
                    </FlexBox>
                  ) : (
                    <FlexBox mb={2} gap={1} alignItems="center">
                      <PhoneAndroid
                        fontSize="small"
                        sx={{ fontSize: 17, mt: "3px" }}
                      />
                      <Span color="#000000">{branch.cellNo}</Span>
                    </FlexBox>
                  )}
                </Box>
              ))}
            </Box>
          </Container>
        </FlexRow>
        <FlexRow alignItems="flex-start" mt={5} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Store Address:
          </H5>
          <Paragraph sx={{ flex: 1, wordBreak: "break-word" }}>
            {companyInfoData.location}
          </Paragraph>
        </FlexRow>
        <FlexRow alignItems="flex-start" my={1} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Facebook page:
          </H5>
          <Paragraph
            onClick={openFacebookPage}
            sx={{
              color: colors.link,
              cursor: "pointer",
              flex: 1,
              wordBreak: "break-word",
            }}
          >
            {companyInfoData.facebookFullUrl}
          </Paragraph>
        </FlexRow>
        <FlexRow alignItems="flex-start" my={1} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Landline Number:
          </H5>
          <Paragraph sx={{ flex: 1, wordBreak: "break-word" }}>
            {companyInfoData.telNo}
          </Paragraph>
        </FlexRow>
        <FlexRow alignItems="flex-start" my={1} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Mobile Number:
          </H5>
          <Paragraph sx={{ flex: 1, wordBreak: "break-word" }}>
            {companyInfoData.cellNo}, {companyInfoData.cellNo2}
          </Paragraph>
        </FlexRow>
        <FlexRow alignItems="flex-start" my={1} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Sales Support:
          </H5>
          <Paragraph
            sx={{ color: colors.link, flex: 1, wordBreak: "break-word" }}
          >
            {companyInfoData.salesSupport}
          </Paragraph>
        </FlexRow>
        <FlexRow alignItems="flex-start" my={1} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Marketing email:
          </H5>
          <Paragraph
            sx={{ color: colors.link, flex: 1, wordBreak: "break-word" }}
          >
            {companyInfoData.marketingEmail}
          </Paragraph>
        </FlexRow>
        <FlexRow alignItems="flex-start" my={1} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Management:
          </H5>
          <Paragraph
            sx={{ color: colors.link, flex: 1, wordBreak: "break-word" }}
          >
            {companyInfoData.managementEmail}
          </Paragraph>
        </FlexRow>
        <FlexRow alignItems="flex-start" my={1} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Human Resources:
          </H5>
          <Paragraph
            sx={{ color: colors.link, flex: 1, wordBreak: "break-word" }}
          >
            hr@pcworth.com
          </Paragraph>
        </FlexRow>
        <FlexRow alignItems="flex-start" my={1} justifyContent="space-between">
          <H5 color="grey.800" sx={{ width: "150px", flexShrink: 0 }}>
            Customer Support:
          </H5>
          <Paragraph sx={{ flex: 1, wordBreak: "break-word" }}>
            {companyInfoData.customerSupport}
          </Paragraph>
        </FlexRow>
      </Container>
    </ShopLayout1>
  );
};

export default ContactUsPage;
